import React from "react";
import ReportByChannel from "./ByChannel";
import ReportByState from "./ByState";
import ReportByUser from "./ByUser";
import ReportByTime from "./ByTime";
import ReportByTicket from "./ByTicket";
import "./style.css";
import { Switch, Route } from "react-router-dom";
import ReportByAgent from "./ByAgent";
import ReportByDepartment from "./ByDepartment";

export default function Reports() {
  return (
    <div style={{ height: "100%", width: "100%", overflow: "auto" }}>
      <Switch>
      <Route
          path="/dashboard/reports/bychannel"
          component={ReportByChannel}
        />
        <Route path="/dashboard/reports/bystate" component={ReportByState} />
        <Route path="/dashboard/reports/byuser" component={ReportByUser} />
        <Route path="/dashboard/reports/byticket" component={ReportByTicket} />
        <Route path="/dashboard/reports/bytime" component={ReportByTime} />
        <Route path="/dashboard/reports/byagent" component={ReportByAgent} />
        <Route path="/dashboard/reports/bydepartment" component={ReportByDepartment} />
      </Switch>
    </div>
  );
}
